import React from 'react';

export default function Home({ onSelectContext }) {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'flex-start',
        paddingTop: '25vh',
        justifyContent: 'center',
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <div>
        <h1 style={{ fontSize: '2.8rem', marginBottom: '0.5rem' }}>
          Welcome to the <span style={{ color: '#149854' }}>Cogello</span> Pilot
        </h1>
        <p style={{ marginBottom: '2.5rem', fontSize: '1.25rem', color: '#000' }}>
          Select the context that best matches your use case:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
          <button
            onClick={() => onSelectContext('clinical')}
            style={buttonStyle}
            onMouseOver={e => hoverStyle(e, true)}
            onMouseOut={e => hoverStyle(e, false)}
          >
            🧠 Clinical
          </button>
          <button
            onClick={() => onSelectContext('education')}
            style={buttonStyle}
            onMouseOver={e => hoverStyle(e, true)}
            onMouseOut={e => hoverStyle(e, false)}
          >
            🎓 Education
          </button>
          <button
            onClick={() => onSelectContext('legal')}
            style={buttonStyle}
            onMouseOver={e => hoverStyle(e, true)}
            onMouseOut={e => hoverStyle(e, false)}
          >
            ⚖️ Legal
          </button>
        </div>
      </div>
    </div>
  );
}

const buttonStyle = {
  backgroundColor: '#eee',
  border: '1px solid #ccc',
  borderRadius: '8px',
  padding: '0.75rem 2rem',
  fontSize: '1.1rem',
  cursor: 'pointer',
  color: '#000',
  transition: 'all 0.3s ease',
  minWidth: '220px', // ✅ Ensures consistent width
  textAlign: 'center',
};

function hoverStyle(e, isHover) {
  e.target.style.backgroundColor = isHover ? '#149854' : '#eee';
  e.target.style.color = isHover ? '#fff' : '#000';
}
